<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div style="width: 100%">
        <div class="col-lg-10 col-md-11 col-sm-12 m-auto">
          <div class="Progress mt-150">
            <h2 class="fl">매물관리(임대인)</h2>

            <ul class="fr">
              <li class="fl pr-80" style="list-style: none">
                <el-button>저장</el-button>
              </li>
              <li class="fl pr-100 position-relative" style="list-style: none">
                <el-button>검수완료</el-button>
                <i class="fas fa-arrow-right P-arrow jipvio-color4"></i>
              </li>
              <li class="fl pr-100 position-relative" style="list-style: none">
                <el-button>매물공개</el-button>
                <i class="fas fa-arrow-right P-arrow jipvio-color4"></i>
              </li>
              <li class="fl pr-40" style="list-style: none">
                <el-button>노출종료</el-button>
              </li>
              <li class="fl" style="list-style: none">
                <router-link to="/mypage/admin/ppt/ler">
                  <el-button round>목록보기</el-button>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-10 col-md-11 col-sm-12 m-auto jipvio-rad cl-bth">
          <!-- 본인인증 -->
          <div class="">
            <span class="propInfoTitle">1. 인증 정보</span>
            <p class="jipvio-color4 mb-0">본인인증</p>
            <card>
              <div slot="header">
                <h3 class="card-title">본인 인증</h3>
                <h5>
                  <i class="fas fa-exclamation-circle"></i>
                  건축물대장상 소유자와의 일치 여부를 확인하는 절차입니다. (현재
                  소유자만 방내놓기 서비스를 이용하실 수 있습니다.)
                </h5>
              </div>
              <div class="row">
                <div class="col-lg-5 fl">
                  <!-- 성명 -->
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >성명</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0 mb-10">
                      <el-input
                        v-model="certification.ownerName"
                        disabled
                      ></el-input>
                    </div>
                  </div>

                  <!-- 휴대전화 -->
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >휴대전화</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0 mb-10">
                      <el-input
                        class="fl r-noradius"
                        style="width: 85%"
                        v-model="certification.ownerTel"
                        disabled
                      >
                      </el-input>
                      <div class="fl" style="width: 15%">
                        <el-button
                          class="jip-cont-btn l-noradius"
                          style="width: 15%"
                          slot="append"
                          disabled
                          >인증</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-7 fl">
                  <div class="row m-row">
                    <!--소유주 주소 -->
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >주소(실거주지)</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0 mb-10">
                      <el-input
                        class="fl r-noradius"
                        style="width: 85%"
                        v-model="certification.ownerAddr"
                        disabled
                      >
                      </el-input>
                      <div class="fl" style="width: 15%">
                        <el-button
                          class="jip-cont-btn l-noradius"
                          icon="el-icon-search"
                          slot="append"
                          disabled
                        ></el-button>
                      </div>
                    </div>
                  </div>

                  <div class="row m-row">
                    <!-- 소유주 상세주소 -->
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >상세주소</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0">
                      <el-input
                        class="mb-10"
                        v-model="certification.ownerAddrDetail"
                        disabled
                      ></el-input>
                      <h6 class="mb-0">
                        <i class="fas fa-exclamation-circle"></i>
                        실제 거주하는 곳을 입력해주세요.(전속중개계약서, 계약서
                        작성 시 필요)
                      </h6>
                      <h6>
                        <i class="fas fa-exclamation-circle"></i>
                        도로명, 건물명, 지번에 대해 통합검색이 가능합니다.
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!-- 인증 내용 -->
          <div class="mt-2">
            <p class="jipvio-color4 mb-0">소유주확인</p>
            <card>
              <div slot="header">
                <h3 class="card-title">인증 내용</h3>
              </div>
              <div class="row">
                <div class="col-lg-4 fl">
                  <!-- 성명 -->
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >성명</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0 mb-10">
                      <el-input
                        v-model="certification.ownerName"
                        disabled
                      ></el-input>
                    </div>
                  </div>

                  <!-- 휴대전화 -->
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >휴대전화</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0 mb-10">
                      <el-input
                        class="fl r-noradius"
                        v-model="certification.ownerTel"
                        disabled
                      >
                      </el-input>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 fl">
                  <!-- 생년월일 -->
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >생년월일</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0 mb-10">
                      <el-input
                        v-model="certification.ownerName"
                        disabled
                      ></el-input>
                    </div>
                  </div>

                  <!-- 성별 -->
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >성별</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0 mb-10">
                      <el-input
                        class="fl r-noradius"
                        v-model="certification.ownerTel"
                        disabled
                      >
                      </el-input>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 fl">
                  <div class="row m-row">
                    <!--건축물대장 등록 -->
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >건축물대장 등록</label
                    >
                    <!-- <div class="col-lg-9 col-md-12 col-sm-12 px-0 mb-10">
                      <el-input
                        class="fl r-noradius"
                        style="width: 85%"
                        v-model="certification.ownerAddr"
                        disabled
                      >
                      </el-input>
                      <div class="fl" style="width: 15%">
                        <el-button
                          class="jip-cont-btn l-noradius"
                          icon="el-icon-search"
                          slot="append"
                          disabled
                        ></el-button>
                      </div>
                    </div> -->
                    <el-upload
                      class="upload-demo uploadFile col-lg-9 col-md-12 col-sm-12 px-0 mb-10"
                      multiple
                      :limit="3"
                      :auto-upload="false"
                      action="#"
                      :on-change="BRgt_UploadChange"
                      :on-remove="BRgt_RemoveFile"
                      :on-exceed="BRgt_ExceedFileLimit"
                      :file-list="B_Rgt_File.fileList"
                    >
                      <el-button
                        size="small"
                        type="primary"
                        style="height: 40px"
                        >File</el-button
                      >
                    </el-upload>
                  </div>

                  <div class="row m-row">
                    <!-- 소유주 여부 -->
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >소유주 여부</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0">
                      <el-input
                        class="mb-10"
                        v-model="certification.ownerAddrDetail"
                        disabled
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!--sohyun-->
          <!-- 매물 위치 정보 -->
          <div class="mt-2">
            <p class="jipvio-color4 mb-0">위치 정보</p>
            <card>
              <div slot="header">
                <h3 class="card-title">매물 위치 정보</h3>
              </div>

              <div class="row">
                <div class="col-lg-8 fl">
                  <div class="mb-30">
                    <h6 class="mb-0">
                      <i class="fas fa-exclamation-circle"></i>
                      건축물대장 상의 주소를 입력해주세요. 건축물대장에서
                      자동으로 매물 정보를 불러옵니다.
                    </h6>
                    <h6>
                      <i class="fas fa-exclamation-circle"></i>
                      도로명, 건물명, 지번에 대해 통합검색이 가능합니다.
                    </h6>
                  </div>
                  <!-- 주소 -->
                  <div class="row m-row">
                    <label class="col-lg-2 col-md-12 col-form-label px-0"
                      >주소</label
                    >
                    <div class="col-lg-10 col-md-12 col-sm-12 px-0 mb-10">
                      <div class="fl r-noradius btn-pct-m" style="width: 90%">
                        <el-input
                          v-model="certification.propertyJAddr"
                          disabled
                        >
                        </el-input>
                      </div>
                      <div class="fl btn-pct-b" style="width: 10%">
                        <el-button
                          class="jip-cont-btn l-noradius"
                          slot="append"
                          icon="el-icon-search"
                          disabled
                        ></el-button>
                      </div>
                    </div>
                  </div>

                  <!--상세주소 -->
                  <div class="row m-row">
                    <label class="col-lg-2 col-md-12 col-form-label px-0"
                      >상세주소</label
                    >
                    <div class="col-lg-10 col-md-12 col-sm-12 px-0">
                      <div class="col-md-6 fl pb-10 px-0">
                        <el-select
                          class="fl AddrDetailSelect"
                          style="width: 100%"
                          v-model="certification.AddrDong"
                          placeholder="해당없음"
                          disabled
                        ></el-select>
                      </div>

                      <div class="col-md-6 fl pb-10 px-0">
                        <el-select
                          style="width: 100%"
                          class="fl AddrDetailSelect"
                          v-model="certification.AddrHo"
                          placeholder="해당없음"
                          disabled
                        ></el-select>
                      </div>

                      <div class="col-md-6 fl pb-0 pl-0 mb-10 pr-0">
                        <el-select
                          style="width: 100%"
                          class="fl AddrDetailSelect"
                          v-model="certification.AddrFloor"
                          placeholder="해당없음"
                          disabled
                        ></el-select>
                      </div>

                      <div
                        class="fl col-12 pb-10 px-0"
                        v-if="certification.flrCheckShow"
                      >
                        <div class="fl col-xl-3 px-0">
                          <el-checkbox
                            label="전체"
                            class="fl col-6 m-0 col-form-label pl-0"
                            v-model="certification.allFloor"
                            disabled
                          ></el-checkbox>
                          <el-checkbox
                            label="일부"
                            class="fl col-6 px-0 col-form-label"
                            v-model="certification.partFloor"
                            disabled
                          ></el-checkbox>
                        </div>

                        <div
                          class="fl col-xl-6 px-0"
                          v-if="certification.partFloor === true"
                        >
                          <el-input
                            class="fl"
                            style="width: 48%"
                            v-model="certification.partArea"
                            disabled
                          >
                            <template slot="append">m²</template>
                          </el-input>
                          <el-input
                            class="fr"
                            v-model="certification.hoTitle"
                            style="width: 48%"
                            disabled
                          >
                            <template slot="append">명칭</template>
                          </el-input>
                        </div>
                      </div>

                      <!-- <div v-show="certification.flrCheckShow"> 
                          <div style="width: 60%" class="fl">
                            <el-checkbox
                              label="전체"
                              class="mr-10 mb-0"
                              v-model="certification.allFloor"
                              disabled
                            ></el-checkbox>
                            <el-checkbox
                              label="일부"
                              class="mb-0"
                              v-model="certification.partFloor"
                              disabled
                            ></el-checkbox>
                          </div> -->
                      <!-- <div
                            class="fl mt-10"
                            style="width: 40%"
                            v-if="certification.partFloor === true"
                          > -->
                      <!-- <div
                            class="fl mt-10"
                            style="width: 40%"
                          >
                            <el-input
                              class="fl"
                              v-model="certification.partArea"
                              style="width: 60px"
                              disabled
                            ></el-input>
                            <span style="font-size: 10px" class="fl">m²</span>
                          </div>
                          <p 
                          class="cl-bth"
                          style=" font-size: 10px">
                            건축물대장과 일치하면 '전체', 일치하지 않을 경우
                            '일부' 선택
                          </p>
                        </div> -->
                    </div>
                  </div>

                  <!-- 주소 정보 -->
                  <div class="row m-row pb-10">
                    <label class="col-lg-2 col-md-12 col-form-label px-0"
                      >주소정보</label
                    >
                    <div class="col-lg-10 col-md-12 col-sm-12 px-0">
                      <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="Please input"
                        v-model="fullAddr"
                        disabled
                      ></el-input>
                    </div>
                  </div>
                </div>

                <!-- map -->
                <div class="col-lg-4 fl">
                  <div class="pptInquiry_map_wrap">
                    <div
                      class="pptInquiry_map_inner"
                      id="step4Map"
                      align="right"
                    ></div>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!-- 건축물 정보 -->
          <div class="mt-10">
            <span class="propInfoTitle">2. 매물 정보</span>
            <card class="mt-15 px-0">
              <div slot="header">
                <h3 class="card-title">건축물 정보</h3>
              </div>
              <div class="row m-row">
                <!-- 용도지역 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">용도지역</label>
                  <div class="fl col-8 pl-0">
                    <el-input
                      v-model="this.brdListForInput"
                      disabled
                    ></el-input>
                  </div>
                </div>

                <!--대지면적 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">대지면적</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="certification.platArea" disabled>
                      <template slot="append">m²</template>
                    </el-input>
                  </div>
                </div>

                <!--연면적 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">연면적</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="certification.totArea" disabled>
                      <template slot="append">m²</template>
                    </el-input>
                  </div>
                </div>

                <!-- 건축물 용도 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">
                    건축물용도
                    <el-tooltip effect="dark" placement="top-start">
                      <div slot="content">
                        건축물 주용도는 건축물대장, 정부와 공공기관이 공개한
                        <br />자료를 바탕으로 자동 입력됩니다. <br />(자료의
                        기준시점에 따라 일치하지 않을 수 있습니다.)
                        <br />집비오의 매물유형은 주용도에 따라 아파트, 빌라,
                        주택 <br />으로 카테고리가 자동 분류됩니다.
                        <br />
                        <br />
                        <el-table :data="clsfData" size="mini" border>
                          <el-table-column
                            prop="clsfByJv"
                            label="집비오 분류"
                            width="100"
                          ></el-table-column>
                          <el-table-column
                            prop="purpsDetail"
                            label="건축물 세부용도"
                            width="150"
                          ></el-table-column>
                          <el-table-column
                            prop="purps"
                            label="건출물용도(건축법)"
                            width="150"
                          ></el-table-column>
                        </el-table>
                      </div>
                      <i class="fas fa-exclamation-circle jipvio-color1"></i>
                    </el-tooltip>
                  </label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="purps" disabled></el-input>
                  </div>
                </div>
                <!-- 건축물 세부용도 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">세부용도</label>
                  <div class="fl col-8 pl-0">
                    <el-input
                      v-model="certification.purpsDetail"
                      disabled
                    ></el-input>
                  </div>
                </div>

                <!--총세대수 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">총 세대수</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="certification.hhldCnt" disabled>
                      <template slot="append">세대</template>
                    </el-input>
                  </div>
                </div>

                <!--명칭 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">명칭</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="certification.bdNm" disabled> </el-input>
                  </div>
                </div>

                <!--사용승인 일자 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0"
                    >사용승인 일자</label
                  >

                  <div class="fl col-8 pl-0">
                    <el-input
                      v-model="certification.useAprDay"
                      disabled
                    ></el-input>
                  </div>
                </div>

                <!-- 총 주차대수 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0"
                    >총 주차대수</label
                  >
                  <div class="fl col-8 pl-0">
                    <el-input v-model="certification.totPkngCnt" disabled>
                      <template slot="append">대</template>
                    </el-input>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!--거래 정보 -->
          <div class="">
            <card id="ler_step4_contrInfo" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">거래 정보</h3>
              </div>
              <div class="row m-row">
                <!-- 거래유형 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">거래유형</label>
                  <div class="fl col-9 pl-0">
                    <el-radio-group v-model="paymentType">
                      <el-radio
                        class="mr-0 m-ml-0"
                        v-for="opt in selects.PTT"
                        :key="opt.value"
                        :label="opt.label"
                        border
                        disabled
                      ></el-radio>
                    </el-radio-group>
                  </div>
                </div>

                <!--보증금 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">보증금</label>
                  <div class="fl col-9 pl-0 mb-10">
                    <el-input v-model="deposit" disabled>
                      <template slot="append">만원</template>
                    </el-input>
                  </div>
                </div>

                <!--월세 -->
                <div
                  class="fl col-lg-6 px-0 mb-10"
                  v-show="selects.PTTMap[paymentType] === 'MP'"
                >
                  <label class="fl col-3 col-form-label px-0">월세</label>
                  <div class="fl col-9 pl-0">
                    <el-input v-model="monthlyPay" disabled>
                      <template slot="append">만원</template>
                    </el-input>
                  </div>
                </div>

                <!-- 입주 가능일 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >입주 가능일</label
                  >
                  <div class="fl col-9 pl-0">
                    <div class="fl mr-10">
                      <ValidationProvider
                        ref="possibleMoveDateVal"
                        rules="required"
                        v-slot="{ failed }"
                      >
                        <fg-input
                          v-show="!imdMove"
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-date-picker
                            ref="PMDPickRef"
                            v-model="possibleMoveDate"
                            type="date"
                            placeholder="날짜선택"
                          ></el-date-picker>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                    <el-checkbox
                      v-show="
                        possibleMoveDate == null ||
                        possibleMoveDate == '0000-00-00'
                      "
                      v-model="imdMove"
                      class="el-checkbox fl px-0 col-form-label"
                      label="즉시입주"
                      @change="delPMD()"
                    ></el-checkbox>
                    <label
                      class="fl pr-0 col-form-label"
                      v-show="
                        possibleMoveDate != null &&
                        possibleMoveDate != '0000-00-00'
                      "
                    >
                      이후 입주협의
                    </label>
                  </div>
                </div>

                <!--전세자금 대출 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label pl-0"
                    >전세자금 대출</label
                  >

                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="loanYnVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="loanYn">
                          <el-radio
                            class="mr-0"
                            ref="loanYnButtonRef"
                            label="1"
                            border
                            >가능</el-radio
                          >
                          <el-radio class="m-ml-0" label="0" border
                            >불가능</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!-- 상세 정보 -->
          <div class="">
            <card id="ler_step4_detailInfo" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">상세 정보</h3>
              </div>
              <div class="row m-row">
                <!-- 공급면적 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">공급면적</label>
                  <div class="fl col-9 mb-10 pl-0">
                    <el-input
                      class="fl"
                      v-model="finalProvArea"
                      disabled
                      style="width: 42%"
                    >
                      <template slot="append">m²</template>
                    </el-input>
                    <i
                      class="fl fas fa-sync-alt AreaIcon m-auto"
                      style="width: 16%; text-align: center"
                    ></i>
                    <el-input
                      class="fr"
                      v-model="supplyAreaP"
                      disabled
                      style="width: 42%"
                    >
                      <template slot="append">평</template>
                    </el-input>
                  </div>
                </div>

                <!--전용면적 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">전용면적</label>

                  <div class="fl col-9 mb-10 pl-0">
                    <el-input
                      style="width: 42%"
                      class="fl"
                      v-model="finalUseArea"
                      disabled
                    >
                      <template slot="append">m²</template>
                    </el-input>
                    <i
                      class="fl fas fa-sync-alt AreaIcon"
                      style="width: 16%; text-align: center"
                    ></i>
                    <el-input
                      class="fr"
                      style="width: 42%"
                      v-model="useAreaP"
                      disabled
                    >
                      <template slot="append">평</template>
                    </el-input>
                  </div>
                </div>

                <!--해당 층/ 총 층 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >해당 층/총 층</label
                  >
                  <div class="fl col-9 pl-0 mb-10">
                    <el-input
                      class="fl"
                      v-model="modifiedFlr"
                      disabled
                      style="width: 42%"
                    >
                      <template slot="append">층</template>
                    </el-input>

                    <font
                      class="fl"
                      size="5px"
                      style="width: 16%; text-align: center"
                      >/</font
                    >
                    <el-input
                      class="fr"
                      style="width: 42%"
                      v-model="certification.grndFlrCnt"
                      disabled
                    >
                      <template slot="append">층</template>
                    </el-input>
                  </div>
                </div>

                <!-- 방 수 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">방 수</label>
                  <div class="fl col-5 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="TNORoomsVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="TNORoomsSelectRef"
                          v-model="TNORooms"
                          placeholder="방 수"
                          @change="TNORoomsDirectWrite()"
                        >
                          <el-option label="1개" value="1"></el-option>
                          <el-option label="2개" value="2"></el-option>
                          <el-option label="3개" value="3"></el-option>
                          <el-option label="4개" value="4"></el-option>
                          <el-option label="직접입력" value="null"></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div class="fr pr-15 TNORooms_wdth" v-if="TNORoomsDirect">
                    <el-input v-model="TNORooms"
                      ><template slot="append">개</template></el-input
                    >
                  </div>
                </div>

                <!--욕실 수 -->

                <div class="fl col-lg-6 px-0">
                  <label class="fl col-3 col-form-label px-0">욕실 수</label>
                  <div class="fl col-5 pl-0 mb-10 jipvio-bg-white">
                    <ValidationProvider
                      ref="TNOBathRoomsVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="TNOBathRoomsSelectRef"
                          v-model="TNOBathRooms"
                          placeholder="욕실 수"
                          @change="TNOBathRoomsDirectWrite()"
                        >
                          <el-option label="1개" value="1"></el-option>
                          <el-option label="2개" value="2"></el-option>
                          <el-option label="3개" value="3"></el-option>
                          <el-option label="4개" value="4"></el-option>
                          <el-option label="직접입력" value="null"></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div class="fr pr-15 TNORooms_wdth" v-if="TNOBathRoomsDirect">
                    <el-input v-model="TNOBathRooms"
                      ><template slot="append">개</template></el-input
                    >
                  </div>
                </div>

                <!--승강기-->
                <div class="fl col-lg-6 px-0">
                  <label class="fl col-3 col-form-label px-0">승강기</label>

                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="eleYnVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="eleYn">
                          <el-radio
                            class="mr-0"
                            ref="eleYnButtonRef"
                            label="1"
                            border
                            >있음</el-radio
                          >
                          <el-radio class="m-ml-0" label="0" border
                            >없음</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!-- 난방방식 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">난방방식</label>
                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="heatingTypeVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="heatingTypeSelectRef"
                          v-model="heatingType"
                          placeholder="난방방식"
                        >
                          <el-option
                            v-for="opt in selects.HTT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--난방연료 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">난방연료</label>
                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="heatingFuelVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="heatingFuelSelectRef"
                          v-model="heatingFuel"
                          placeholder="난방연료"
                        >
                          <el-option
                            v-for="opt in selects.HFT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--현관구조 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">현관구조</label>

                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="entStructureVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="entStrSelectRef"
                          v-model="entStructure"
                          placeholder="현관구조"
                        >
                          <el-option
                            v-for="opt in selects.ETT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--방향 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-sm-3 col-3 col-form-label px-0">
                    방향
                    <el-tooltip effect="dark" placement="top-start">
                      <div slot="content">
                        &lt;방향기준&gt;
                        <br />주거용: 거실, 안방 등 주실 기준 <br />그 밖의
                        건물: 주 출입구 기준
                      </div>
                      <i class="fas fa-exclamation-circle jipvio-color1"></i>
                    </el-tooltip>
                  </label>

                  <div class="fl col-sm-4 col-4 px-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="directionStdVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="directionStdSelectRef"
                          v-model="directionStd"
                          placeholder="기준"
                        >
                          <el-option
                            v-for="opt in selects.DST"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div class="fl col-sm-4 col-4 pr-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="directionVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="directionSelectRef"
                          v-model="direction"
                          placeholder="방향"
                        >
                          <el-option
                            v-for="opt in selects.DRT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!-- 베란다/발코니 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label pl-0"
                    >베란다/발코니</label
                  >
                  <div class="fl col-9 col-6 px-0">
                    <el-checkbox
                      v-model="verandaYn"
                      label="베란다"
                      border
                      class="ml-0 mr-0"
                    ></el-checkbox>
                    <el-checkbox
                      class="ml-0 mr-0"
                      v-model="balconyYn"
                      label="발코니"
                      border
                    ></el-checkbox>
                  </div>
                </div>

                <!--주차가능대수 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-sm-3 col-3 col-form-label pl-0"
                    >주차가능대수</label
                  >

                  <div class="fl col-md-3 col-sm-3 col-8 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="parkingYnVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="parkingYnSelectRef"
                          v-model="parkingYn"
                          placeholder="주차"
                        >
                          <el-option label="가능" value="1"></el-option>
                          <el-option label="불가능" value="0"></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div
                    v-if="Number(parkingYn) === 1"
                    class="col-sm-6 row m-row px-0"
                  >
                    <label class="fr col-3 pl-0 pr-10 col-form-label"
                      >가구당</label
                    >
                    <ValidationProvider
                      ref="pknPerFmlyVal"
                      rules="required"
                      v-slot="{ failed }"
                      class="fr col-9 px-0"
                    >
                      <fg-input
                        :error="
                          failed ? '가구 당 주차대수를 입력해주세요.' : null
                        "
                        class="fl"
                      >
                        <el-input v-model="PknPerFmly" type="number"
                          ><template slot="append">대</template>
                        </el-input>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- 관리비-->
                <div class="fl col-lg-6 px-0 mb-10 row m-row">
                  <label class="fl col-lg-3 col-3 col-form-label px-0"
                    >관리비</label
                  >
                  <div
                    class="fl maintenanceFee col-xl-4 col-md-8 col-sm-7 col-7 px-0"
                  >
                    <ValidationProvider
                      ref="maintenanceFeeVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        type="number"
                        class="fl px-0"
                        :error="failed ? '필수 입력 항목입니다!' : null"
                        v-model="maintenanceFee"
                        label="만원"
                        style="width: 100%"
                      ></fg-input>
                    </ValidationProvider>
                  </div>
                  <div
                    class="fl col-xl-5 col-12 maintenanceFee px-0 row m-row m-0"
                  >
                    <label
                      class="col-xl-4 col-3 col-form-label pl-0"
                      id="maintenancefeelistlabel"
                      >관리비항목</label
                    >
                    <el-select
                      class="fl col-xl-8 col-9 pl-0 ft-18"
                      ref="maintenListSelectRef"
                      v-model="maintenList"
                      placeholder="관리비항목"
                      multiple
                      style="width: 100%"
                    >
                      <el-option
                        v-for="opt in selects.MTN"
                        :key="opt.value"
                        :label="opt.label"
                        :value="opt.value"
                        class="fl"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <!--사용료 -->
                <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
                  <label class="fl col-3 col-form-label px-0">사용료</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="useFeeYnVal"
                      rules="required"
                      v-slot="{ failed }"
                      class="fl mr-10"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="useFeeYn">
                          <el-radio
                            class="ml-0 mr-0"
                            ref="useFeeYnButtonRef"
                            label="1"
                            border
                            >있음</el-radio
                          >
                          <el-radio
                            class="m-ml-0"
                            label="0"
                            border
                            @change="useFeeList = []"
                            >없음</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                    <!-- <el-input class="fl" style="width:60px" v-model="useFee"></el-input> -->

                    <div v-if="Number(useFeeYn) === 1">
                      <ValidationProvider
                        ref="useFeeListSelectVal"
                        rules="required"
                        v-slot="{ failed }"
                        class="fl col-md-7 px-0"
                      >
                        <fg-input
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-select
                            ref="useFeeListSelectRef"
                            v-model="useFeeList"
                            placeholder="사용료항목"
                            multiple
                            class="fl ft-18"
                          >
                            <el-option
                              v-for="opt in selects.UUF"
                              :key="opt.value"
                              :label="opt.label"
                              :value="opt.value"
                            ></el-option>
                          </el-select>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!--부가 정보 -->
          <div class="">
            <card id="ler_step4_extrInfo" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">부가 정보</h3>
              </div>
              <div class="row m-row">
                <!-- 옵션 -->
                <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
                  <label class="fl col-3 col-form-label px-0">옵션</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="optionYnVal"
                      rules="required"
                      v-slot="{ failed }"
                      class="fl mr-10"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="optionYn">
                          <el-radio
                            class="ml-0 mr-0"
                            ref="optionYnButtonRef"
                            label="1"
                            border
                            >있음</el-radio
                          >
                          <el-radio
                            class="m-ml-0"
                            label="0"
                            border
                            @change="optionList = []"
                            >없음</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>

                    <div v-if="Number(optionYn) === 1">
                      <ValidationProvider
                        ref="optionListSelectVal"
                        rules="required"
                        v-slot="{ failed }"
                        class="fl px-0 col-md-7"
                      >
                        <fg-input
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-select
                            v-model="optionList"
                            multiple
                            placeholder="옵션"
                            class="fl ft-18"
                          >
                            <el-option
                              v-for="opt in selects.BIO"
                              :key="opt.value"
                              :label="opt.label"
                              :value="opt.value"
                            ></el-option>
                          </el-select>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <!--보안시설 -->
                <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
                  <label class="fl col-3 col-form-label px-0">보안시설</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="securityYnVal"
                      rules="required"
                      v-slot="{ failed }"
                      class="fl mr-10"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="securityYn">
                          <el-radio class="mr-0" label="1" border
                            >있음</el-radio
                          >
                          <el-radio
                            class="m-ml-0"
                            label="0"
                            border
                            @change="securityList = []"
                            >없음</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>

                    <div v-if="Number(securityYn) === 1">
                      <ValidationProvider
                        ref="securityListSelectVal"
                        rules="required"
                        v-slot="{ failed }"
                        class="fl px-0 col-md-7"
                      >
                        <fg-input
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-select
                            v-show="Number(securityYn) === 1"
                            v-model="securityList"
                            placeholder="보안시설"
                            multiple
                            class="fl ft-18"
                          >
                            <el-option
                              v-for="opt in selects.SCF"
                              :key="opt.value"
                              :label="opt.label"
                              :value="opt.value"
                            ></el-option>
                          </el-select>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <!--반려동물-->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">반려동물</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="petYnVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="petYn">
                          <el-radio class="mr-0" label="1" border
                            >가능</el-radio
                          >
                          <el-radio
                            class="m-ml-0"
                            ref="petYnButtonRef"
                            label="0"
                            border
                            >불가능
                          </el-radio>
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!-- 방문 가능 요일 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label pl-0"
                    >방문 가능 요일</label
                  >
                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="possibleVisitDaysVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="PVDSelectRef"
                          v-model="possibleVisitDays"
                          multiple
                          placeholder="방문 가능 요일"
                        >
                          <el-option
                            v-for="opt in selects.VPD"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--방문 가능 시간 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label pl-0"
                    >방문 가능 시간</label
                  >

                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="possibleVisitTimesVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          ref="PVTSelectRef"
                          v-model="possibleVisitTimes"
                          multiple
                          placeholder="방문 가능 시간"
                        >
                          <el-option
                            v-for="opt in selects.VPT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!-- ======================================================================= -->
          <!--추가 설명 -->
          <div class="">
            <card class="mt-15">
              <div slot="header">
                <h3 class="card-title">추가 설명</h3>
              </div>
              <el-input
                v-model="extrExpl"
                type="textarea"
                :rows="4"
                placeholder="매물에 대한 추가 설명을 작성해주세요."
              ></el-input>
            </card>
          </div>

          <!-- 일반이미지 파일 업로드 -->

          <div class="">
            <card id="ler_step4_GImgUpl" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">일반 사진 등록</h3>
              </div>
              <div class="jipvio-color4" style="font-size: 0.85em">
                <p style="font-weight: 400">
                  - jpg, png, jpeg 등의 이미지 확장자 파일로 최소 2장 이상
                  등록합니다.<br />
                  - 해당 중개물과 관련된 실 사진만 첨부하시길 바랍니다. (그 외
                  관계없는 이미지는 삭제될 수 있습니다.)<br />
                  - 첨부한 사진이 많거나 용량이 클 경우 업로드 시간이 다소
                  지연될 수 있습니다.
                </p>
                <h4>매물 사진 업로드</h4>
              </div>
              <div class="col-12 px-0">
                <el-upload
                  class="upload-demo text-center"
                  drag
                  :limit="3"
                  :auto-upload="false"
                  action="#"
                  :on-change="G_UploadChange"
                  :on-remove="G_RemoveFile"
                  :on-exceed="G_ExceedFileLimit"
                  :file-list="G_Img_File.fileList"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    파일을 여기로 끌어 놓으세요.<br />혹은
                    <em>클릭해주세요.</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    사이즈 500kb 미만의 jpg/png 파일로 제한
                  </div>
                </el-upload>
              </div>
            </card>
          </div>

          <!-- 열화상 업로드 -->

          <div class="">
            <card id="ler_step4_GImgUpl" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">열화상 사진 등록</h3>
              </div>
              <div class="jipvio-color4" style="font-size: 0.85em">
                <p style="font-weight: 400">
                  - jpg, png, jpeg 등의 이미지 확장자 파일로 최소 2장 이상
                  등록합니다.<br />
                  - 해당 중개물과 관련된 실 사진만 첨부하시길 바랍니다. (그 외
                  관계없는 이미지는 삭제될 수 있습니다.)<br />
                  - 첨부한 사진이 많거나 용량이 클 경우 업로드 시간이 다소
                  지연될 수 있습니다.
                </p>
                <h4>매물 사진 업로드</h4>
              </div>
              <div class="col-12 px-0">
                <el-upload
                  class="upload-demo text-center"
                  drag
                  :limit="3"
                  :auto-upload="false"
                  action="#"
                  :on-change="TH_UploadChange"
                  :on-remove="TH_RemoveFile"
                  :on-exceed="TH_ExceedFileLimit"
                  :file-list="TH_Img_File.fileList"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    파일을 여기로 끌어 놓으세요.<br />혹은
                    <em>클릭해주세요.</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    사이즈 500kb 미만의 jpg/png 파일로 제한
                  </div>
                </el-upload>
              </div>
            </card>
          </div>

          <!-- VR 파일 업로드 -->

          <div class="">
            <card id="ler_step4_GImgUpl" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">360˚ VR 등록</h3>
              </div>
              <div class="jipvio-color4" style="font-size: 0.85em">
                <p style="font-weight: 400">
                  - 360˚ 사진은 VR전용 카메라나 스마트폰 파노라마 촬영 기능을
                  활용하여 만드실 수 있습니다.<br />
                  - jpeg 이미지 확장자 형식의 파일로 등록이 가능합니다.
                </p>
                <h4>매물 사진 업로드</h4>
              </div>
              <div class="col-12 px-0">
                <el-upload
                  class="upload-demo text-center"
                  drag
                  :limit="3"
                  :auto-upload="false"
                  action="#"
                  :on-change="VR_UploadChange"
                  :on-remove="VR_RemoveFile"
                  :on-exceed="VR_ExceedFileLimit"
                  :file-list="VR_Img_File.fileList"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    파일을 여기로 끌어 놓으세요.<br />혹은
                    <em>클릭해주세요.</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    사이즈 500kb 미만의 jpg/png 파일로 제한
                  </div>
                </el-upload>
              </div>
            </card>
          </div>

          <!--기타 의견 -->
          <div class="">
            <card class="mt-15">
              <div slot="header">
                <h3 class="card-title">기타 의견</h3>
              </div>
              <el-input
                v-model="etcComment"
                type="textarea"
                :rows="4"
                placeholder="집비오에게 하고 싶은 말이 있으신가요? 여기에 남겨주세요."
              ></el-input>
            </card>
          </div>
        </div>
      </div>
    </form>

    <div class="col-lg-10 col-md-11 col-sm-12 m-auto">
      <div class="Progress">
        <ul class="fr mt-50 mb-100">
          <li class="fl pr-80" style="list-style: none">
            <el-button>저장</el-button>
          </li>
          <li class="fl pr-100 position-relative" style="list-style: none">
            <el-button>검수완료</el-button>
            <i class="fas fa-arrow-right P-arrow jipvio-color4"></i>
          </li>
          <li class="fl pr-100 position-relative" style="list-style: none">
            <el-button>매물공개</el-button>
            <i class="fas fa-arrow-right P-arrow jipvio-color4"></i>
          </li>
          <li class="fl pr-40" style="list-style: none">
            <el-button>노출종료</el-button>
          </li>
          <li class="fl" style="list-style: none">
            <router-link to="/mypage/admin/ppt/ler">
              <el-button round>목록보기</el-button>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </ValidationObserver>
</template>
<script>
import ServiceInfo from "@/pages/jipvio/GeneralViews/ServiceInfo.vue";
import propApi from "@/service/property";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { FormGroupInput as FgInput } from "@/components";
import { createNamespacedHelpers, mapGetters } from "vuex";
import filestoreApi from "@/service/filestore";

const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters,
} = createNamespacedHelpers("loginSession");

extend("required", required);

import {
  Card,
  Button,
  CheckboxGroup,
  Checkbox,
  Input,
  Select,
  Option,
  RadioGroup,
  Radio,
  DatePicker,
  Tooltip,
  Table,
  TableColumn,
  Message,
  Upload,
} from "element-ui";

export default {
  components: {
    ServiceInfo,
    FgInput,
    Card,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [DatePicker.name]: DatePicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
  },
  data() {
    return {
      jipvioMarker: null,
      jipvioMap: null,
      jipvioGeocoder: null,
      locationInfo: {},

      possibleMoveDate: null, // 입주가능일
      imdMove: false, // 즉시입주(true, false)
      loanYn: null, //전세자금대출 가능여부

      TNORooms: null, //방 수
      TNORoomsDirect: false, // 방 수 직접선택 체크박스
      TNOBathRooms: null, //욕실 수
      TNOBathRoomsDirect: null, //욕실 수 직접선택 체크박스
      eleYn: null, // 승강기 여부
      heatingType: null, //난방방식
      heatingFuel: null, //난방연료
      entStructure: null, //현관구조
      directionStd: null, //방향 기준
      direction: null, //방향
      verandaYn: false, //베란다 체크박스
      balconyYn: false, // 발코니 체크박스
      parkingYn: null, // 주차가능여부
      PknPerFmly: null, // 가구당 주차가능대수
      maintenanceFee: null, //관리비
      maintenList: [], //선택된 관리비 포함항목
      useFeeYn: null, //사용료
      useFeeList: [], //사용료 포함내역

      optionYn: null, //옵션유무
      optionList: [], //선택된 옵션들
      securityYn: null,
      securityList: [], //선택된 보안시설
      petYn: null, //반려동물 가능여부
      possibleVisitDays: [], //방문 가능 요일
      possibleVisitTimes: [], //방문 가능 시간

      selects: {
        BIO: [],
        PTT: [],
        PTTMap: {},
        ETT: [],
        HTT: [],
        HFT: [],
        MPM: [],
        USR: [],
        VPD: [],
        VPT: [],
        MTN: [],
        SCF: [],
        DRT: [],
        UUF: [],
        DST: [],
      },

      clsfData: [
        {
          clsfByJv: "아파트",
          purpsDetail: "아파트",
          purps: "공동주택",
        },
        {
          clsfByJv: "빌라",
          purpsDetail: "다세대, 연립",
          purps: "공동주택",
        },
        {
          clsfByJv: "주택",
          purpsDetail: "단독, 다중, 다가구",
          purps: "단독주택",
        },
        {
          clsfByJv: "오피스텔",
          purpsDetail: "업무시설(오피스텔)",
          purps: "업무시설",
        },
        {
          clsfByJv: "원룸",
          purpsDetail: "정의되어 있지 않음",
          purps: "정의되어 있지 않음",
        },
      ],

      extrExpl: null, //추가설명
      oneHouseAgr: null, //단독주택일 경우 동의 체크박스
      shareHouseAgr: null, //공동주택일 경우 동의 체크박스

      /* Building Register(건축물대장) */
      B_Rgt_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: [],
      },
      /* 일반 이미지 */
      G_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: [],
      },
      /* 열화상 이미지 */
      TH_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: [],
      },
      /* VR이미지 */
      VR_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: [],
      },

      etcComment: null, //기타 의견

      isEtv: false, // extraValidation 에 걸렸는지 //===============================================================================20201106 him

      //끝
    };
  },
  created() {
    this.bringData();
    this.applyCommonCode();
  },
  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionPropertyInquiry: "getPropertyInquiry",
      sessionCoCodeMapDetail: "getCoCodeMapDetail",
    }),

    certification() {
      return this.sessionPropertyInquiry.certification;
    },

    contractInfo() {
      return this.sessionPropertyInquiry.contractInfo;
    },

    purps() {
      if (this.certification.purpsDetail != null) {
        const purp = this.certification.purpsDetail;
        if (
          purp.search("아파트") != -1 ||
          purp.search("다세대") != -1 ||
          purp.search("연립") != -1 ||
          purp.search("공동주택") != -1
        ) {
          return "PBH";
        } else if (
          purp.search("단독") != -1 ||
          purp.search("다중") != -1 ||
          purp.search("다가구") != -1
        ) {
          return "SFH";
        } else if (
          purp.search("오피스텔") != -1 ||
          purp.search("업무시설") != -1
        ) {
          return "BSF";
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    fullAddr() {
      if (
        this.sessionPropertyInquiry.certification.fullRAddr == null ||
        this.sessionPropertyInquiry.certification.fullJAddr == null
      ) {
        return "도로명: " + "\n" + "지번:";
      } else {
        return (
          "도로명: " +
          this.sessionPropertyInquiry.certification.fullRAddr +
          "\n" +
          "지번:" +
          this.sessionPropertyInquiry.certification.fullJAddr
        );
      }
    },

    supplyAreaP() {
      return Math.round(this.finalProvArea * 0.3025);
    },

    useAreaP() {
      return Math.round(this.finalUseArea * 0.3025);
    },

    modifiedDong() {
      if (
        this.certification.AddrDong != null &&
        this.certification.AddrDong.charAt(
          this.certification.AddrDong.length - 1
        ) == "동"
      ) {
        return this.certification.AddrDong.slice(0, -1);
      } else if (this.certification.AddrDong != null) {
        return this.certification.AddrDong;
      } else {
        return null;
      }
    },

    modifiedHo() {
      if (
        this.certification.AddrHo != null &&
        this.certification.AddrHo.charAt(
          this.certification.AddrHo.length - 1
        ) == "호"
      ) {
        return this.certification.AddrHo.slice(0, -1);
      } else if (this.certification.AddrHo != null) {
        return this.certification.AddrHo;
      } else {
        return null;
      }
    },

    modifiedFlr() {
      if (
        this.certification.AddrFloor != null &&
        this.certification.AddrFloor.charAt(
          this.certification.AddrFloor.length - 1
        ) == "층"
      ) {
        return this.certification.AddrFloor.slice(0, -1);
      } else {
        return this.certification.AddrFloor;
      }
    },

    brdListForInput() {
      let brdL = "";

      if (this.certification.brdList != null) {
        if (this.certification.brdList.length == 1) {
          return this.certification.brdList[0];
        } else {
          for (var i = 0; i < this.certification.brdList.length - 1; i++) {
            brdL = brdL + this.certification.brdList[i] + ",";
          }
          return (
            brdL +
            this.certification.brdList[this.certification.brdList.length - 1]
          );
        }
      } else {
        return null;
      }
    },

    modifiedPMD() {
      let PMD = this.possibleMoveDate;
      if (PMD != "0000-00-00") {
        PMD = this.$moment(PMD).format("YYYY-MM-DD");
        return PMD;
      } else {
        return PMD;
      }
    },

    paymentType() {
      if (this.contractInfo.leaseYn == true) {
        return "전세";
      } else if (this.contractInfo.leaseYn == false) {
        return "월세";
      }
    },

    deposit() {
      return (this.contractInfo.deposit / 10000).toFixed(0);
    },

    monthlyPay() {
      return (this.contractInfo.monthlyPay / 10000).toFixed(0);
    },
    isOnlyRoom() {
      if (this.TNORooms == 1) {
        return true;
      } else {
        return false;
      }
    },

    isUseFee() {
      if (this.useFee == "1") {
        return true;
      } else {
        return false;
      }
    },

    finalProvArea() {
      if (this.certification.partArea != 0) {
        return this.certification.partArea;
      } else {
        return this.certification.provArea;
      }
    },

    finalUseArea() {
      if (this.certification.partArea != 0) {
        return this.certification.partArea;
      } else {
        return this.certification.useArea;
      }
    },
  },
  watch: {},

  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement("script");
      /* global kakao */
      const serviceKey = process.env.VUE_APP_KKO_SDK_KEY;

      script.onload = () => kakao.maps.load(this.initMap);

      script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${serviceKey}&libraries=services`;
      // <head></head>에 위치
      document.head.appendChild(script);
    }
  },

  methods: {
    //===========================================================20201106 him
    // resizeMap() {
    //   this.jipvioMap.relayout();
    // },

    ...sessionMapActions(["savePropertyInquiryStep4"]),

    // async getPropertyDetail() {
    //   const res = await propApi.getPropertyDetail(
    //     "A7ZQOr_VzS-8hOC5NjmzSg%3D%3D"
    //   );
    //   console.log("Detail조회 결과");
    //   console.log(res.payload);

    //   this.PropertyDetail = res.payload;
    //   console.log(this.PropertyInfo);
    // },

    async bringData() {
      const res = await propApi.getPropertyDetail(
        "A7ZQOr_VzS-8hOC5NjmzSg%3D%3D"
      );
      console.log("Detail조회 결과");
      console.log(res.payload);

      this.TNORooms = res.payload.roomCnt; //방 수
      this.TNOBathRooms = res.payload.wroomCnt; //욕실 수
      this.eleYn = res.payload.eleYn; // 승강기 여부
      this.heatingType = this.sessionPropertyInquiry.propertyInfo.heatingType; //난방방식
      this.heatingFuel = this.sessionPropertyInquiry.propertyInfo.heatingFuel; //난방연료
      this.entStructure = this.sessionPropertyInquiry.propertyInfo.entStructure; //현관구조
      this.directionStd = this.sessionPropertyInquiry.propertyInfo.directionStd; //방향 기준
      this.direction = this.sessionPropertyInquiry.propertyInfo.direction; //방향
      this.verandaYn = this.sessionPropertyInquiry.propertyInfo.verandaYn; //베란다 체크박스
      this.balconyYn = this.sessionPropertyInquiry.propertyInfo.balconyYn; // 발코니 체크박스
      this.parkingYn = Number(
        this.sessionPropertyInquiry.propertyInfo.parkingYn
      ).toString(); // 주차가능여부
      this.PknPerFmly = Number(
        this.sessionPropertyInquiry.propertyInfo.PknPerFmly
      ); // 가구당 주차가능대수
      this.maintenanceFee = Number(res.payload.mtncFee); //관리비
      this.maintenList = this.sessionPropertyInquiry.propertyInfo.mtncFee; //선택된 관리비 포함항목
      this.useFeeYn = Number(
        this.sessionPropertyInquiry.propertyInfo.useFeeYn
      ).toString(); //사용료 유무
      this.useFeeList = this.sessionPropertyInquiry.propertyInfo.useFeeList; //사용료 포함내역
      this.optionYn = Number(
        this.sessionPropertyInquiry.propertyInfo.optionYn
      ).toString(); //옵션유무
      this.optionList = this.sessionPropertyInquiry.propertyInfo.optionList; //선택된 옵션들
      this.securityYn = Number(
        this.sessionPropertyInquiry.propertyInfo.securityYn
      ).toString();
      this.securityList = this.sessionPropertyInquiry.propertyInfo.securityList; //선택된 보안시설
      this.petYn = Number(
        this.sessionPropertyInquiry.propertyInfo.petYn
      ).toString(); //반려동물 가능여부
      this.possibleVisitDays = this.sessionPropertyInquiry.propertyInfo.possibleVisitDays; //방문 가능 요일
      this.possibleVisitTimes = this.sessionPropertyInquiry.propertyInfo.possibleVisitTimes; //방문 가능 시간
      this.extrExpl = this.sessionPropertyInquiry.propertyInfo.extrExpl; //추가설명
      this.oneHouseAgr = this.sessionPropertyInquiry.propertyInfo.oneHouseAgr; //단독주택일 경우 동의 체크박스
      this.shareHouseAgr = this.sessionPropertyInquiry.propertyInfo.shareHouseAgr; //공동주택일 경우 동의 체크박스
      this.G_Img_File = this.sessionPropertyInquiry.propertyInfo.G_Img_File; //일반이미지
      this.etcComment = this.sessionPropertyInquiry.propertyInfo.etcComment; //기타 의견

      // this.locationInfo = this.sessionPropertyInquiry.propertyInfo.locationInfo;
      // this.possibleMoveDate = this.sessionPropertyInquiry.propertyInfo.pmdNotMdf; // 입주가능일
      // this.imdMove = this.sessionPropertyInquiry.propertyInfo.imdMove; // 즉시입주(true, false)
      // if (this.sessionPropertyInquiry.propertyInfo !== null) {
      //   this.loanYn = Number(
      //     this.sessionPropertyInquiry.propertyInfo.loanYn
      //   ).toString(); //전세자금대출 가능여부
      // }
      // this.TNORooms = this.sessionPropertyInquiry.propertyInfo.TNORooms; //방 수
      // this.TNORoomsDirect = this.sessionPropertyInquiry.propertyInfo.TNORoomsDirect; // 방 수 직접선택 체크박스
      // this.TNOBathRooms = this.sessionPropertyInquiry.propertyInfo.TNOBathRooms; //욕실 수
      // this.TNOBathRoomsDirect = this.sessionPropertyInquiry.propertyInfo.TNOBathRoomsDirect; //욕실 수 직접선택 체크박스
      // this.eleYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.eleYn
      // ).toString(); // 승강기 여부
      // this.heatingType = this.sessionPropertyInquiry.propertyInfo.heatingType; //난방방식
      // this.heatingFuel = this.sessionPropertyInquiry.propertyInfo.heatingFuel; //난방연료
      // this.entStructure = this.sessionPropertyInquiry.propertyInfo.entStructure; //현관구조
      // this.directionStd = this.sessionPropertyInquiry.propertyInfo.directionStd; //방향 기준
      // this.direction = this.sessionPropertyInquiry.propertyInfo.direction; //방향
      // this.verandaYn = this.sessionPropertyInquiry.propertyInfo.verandaYn; //베란다 체크박스
      // this.balconyYn = this.sessionPropertyInquiry.propertyInfo.balconyYn; // 발코니 체크박스
      // this.parkingYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.parkingYn
      // ).toString(); // 주차가능여부
      // this.PknPerFmly = Number(
      //   this.sessionPropertyInquiry.propertyInfo.PknPerFmly
      // ); // 가구당 주차가능대수
      // this.maintenanceFee = Number(this.purpsDetail.mtncFee); //관리비
      // this.maintenList = this.sessionPropertyInquiry.propertyInfo.mtncFee; //선택된 관리비 포함항목
      // this.useFeeYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.useFeeYn
      // ).toString(); //사용료 유무
      // this.useFeeList = this.sessionPropertyInquiry.propertyInfo.useFeeList; //사용료 포함내역
      // this.optionYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.optionYn
      // ).toString(); //옵션유무
      // this.optionList = this.sessionPropertyInquiry.propertyInfo.optionList; //선택된 옵션들
      // this.securityYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.securityYn
      // ).toString();
      // this.securityList = this.sessionPropertyInquiry.propertyInfo.securityList; //선택된 보안시설
      // this.petYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.petYn
      // ).toString(); //반려동물 가능여부
      // this.possibleVisitDays = this.sessionPropertyInquiry.propertyInfo.possibleVisitDays; //방문 가능 요일
      // this.possibleVisitTimes = this.sessionPropertyInquiry.propertyInfo.possibleVisitTimes; //방문 가능 시간
      // this.extrExpl = this.sessionPropertyInquiry.propertyInfo.extrExpl; //추가설명
      // this.oneHouseAgr = this.sessionPropertyInquiry.propertyInfo.oneHouseAgr; //단독주택일 경우 동의 체크박스
      // this.shareHouseAgr = this.sessionPropertyInquiry.propertyInfo.shareHouseAgr; //공동주택일 경우 동의 체크박스
      // this.G_Img_File = this.sessionPropertyInquiry.propertyInfo.G_Img_File; //일반이미지
      // this.etcComment = this.sessionPropertyInquiry.propertyInfo.etcComment; //기타 의견
    },

    saveStep() {
      this.saveStep4Info();
    },

    saveStep4Info() {
      console.log("step4 Action!");

      let propertyInfo = {
        // ownerName: this.certification.ownerName, //소유주 이름
        // ownerAddr: this.certification.ownerAddr, // 소유주 주소
        // ownerAddrDetail: this.certification.ownerAddrDetail, //소유주 상세주소
        // ownerTel: this.certification.ownerTel, // 소유주 휴대폰

        propertyJAddr: this.certification.propertyJAddr, //건물 지번 주소
        propertyRAddr: this.certification.propertyRAddr, //건물 도로명 주소
        propertyLat: Number(this.certification.propertyLat), // 위도
        propertyLong: Number(this.certification.propertyLong), // 경도

        AddrDong: this.certification.AddrDong, //동
        AddrHo: this.certification.AddrHo, //호
        AddrFloor: this.certification.AddrFloor, //층
        flrJustNum: this.modifiedFlr, // 층 숫자만
        hoJustNm: this.modifiedHo, // 호 이름만
        dongJustNm: this.modifiedDong, // 동 이름만

        locationInfo: this.certification.locationInfo,
        fullRAddr: this.certification.fullRAddr, //주소+동호층 (도로명)
        fullJAddr: this.certification.fullJAddr, //주소+동호층 (지번)
        jiBun: this.certification.jiBun, // 지번주소의 지번
        legalDong: this.certification.legalDong, // 법정동

        allFloor: this.certification.allFloor, // 층 전체 체크박스
        partFloor: this.certification.partFloor, //층 일부 체크박스

        //=============================================
        strct: this.certification.strct, //건축물 구조
        rawBrdList: this.certification.brdList, // 용도지역 원본 리스트 (ex)['일반주거지역', '공업지역'])
        brdList: this.brdListForInput, // 용도지역 String (ex) 일반주거지역, 공업지역)
        purps: this.purps, //건축물 용도(건축법)
        purpsDetail: this.certification.purpsDetail, // 건축물 세부용도(api)
        jpvTypeCd: this.certification.jpvTypeCd, //아파트, 빌라, 주택, 오피스텔
        isOnlyRoom: this.isOnlyRoom, //원룸 여부
        platArea: this.certification.platArea, // 대지면적
        totArea: this.certification.totArea, // 연면적
        hhldCnt: this.certification.hhldCnt, // 총 세대수
        bdNm: this.certification.bdNm, // 건축물 명
        permitDate: this.certification.useAprDay, //사용승인 일자
        totPkngCnt: this.certification.totPkngCnt, //총 주차대수

        paymentType: this.selects.PTTMap[this.paymentType], //거래유형
        deposit: Number(this.contractInfo.deposit), //보증금
        monthlyPay: Number(this.contractInfo.monthlyPay), //월세
        pmdNotMdf: this.possibleMoveDate, // 포맷 수정 안된 입주가능일(불러오기 용도)
        possibleMoveDate: this.modifiedPMD, // formmat수정 입주가능일
        imdMove: this.imdMove, // 즉시입주(true, false)
        loanYn: Boolean(Number(this.loanYn)), //전세자금대출 가능여부

        provArea: this.finalProvArea, // 공급면적
        useArea: this.finalUseArea, //전용면적
        grndFlrCnt: this.certification.grndFlrCnt, //총 층
        TNORooms: Number(this.TNORooms), //방 수
        TNORoomsDirect: this.TNORoomsDirect, //방개수 직접입력인지 아닌지
        TNOBathRooms: Number(this.TNOBathRooms), //욕실 수
        TNOBathRoomsDirect: this.TNOBathRoomsDirect, //욕실개수 직접입력인지 아닌지
        eleYn: Boolean(Number(this.eleYn)), // 승강기 여부
        heatingType: this.heatingType, //난방방식
        heatingFuel: this.heatingFuel, //난방연료
        entStructure: this.entStructure, //현관구조
        directionStd: this.directionStd, //방향 기준
        direction: this.direction, //방향
        verandaYn: this.verandaYn, //베란다 체크박스
        balconyYn: this.balconyYn, // 발코니 체크박스
        parkingYn: Boolean(Number(this.parkingYn)), // 주차가능여부
        PknPerFmly: Number(this.PknPerFmly), // 가구당 주차가능대수
        maintenanceFee: Number(this.maintenanceFee) * 10000, //관리비
        maintenList: this.maintenList, //선택된 관리비 포함항목
        useFeeYn: Boolean(Number(this.useFeeYn)), //사용료
        useFeeList: this.useFeeList, //선택된 사용료 포함항목

        optionYn: Boolean(Number(this.optionYn)), //옵션 유무
        optionList: this.optionList, //선택된 옵션들
        securityYn: Boolean(Number(this.securityYn)), //보안시설 유무
        securityList: this.securityList, //선택된 보안시설
        petYn: Boolean(Number(this.petYn)), // 반려동물 가능여부
        possibleVisitDays: this.possibleVisitDays, //방문 가능 요일
        possibleVisitTimes: this.possibleVisitTimes, //방문 가능 시간

        extrExpl: this.extrExpl, //매물 추가 설명

        oneHouseAgr: this.oneHouseAgr, // 추가정보 동의 YN (단독주택 경우)
        shareHouseAgr: this.shareHouseAgr, // 추가정보 동의 YN (공동주택 경우)

        G_Img_File: this.G_Img_File, // 일반이미지

        etcComment: this.etcComment, //기타 의견
      };
      this.savePropertyInquiryStep4(propertyInfo);
      console.log(this.sessionPropertyInquiry);
    },

    extraValidation() {
      this.isEtv = false;
      let errMsg = [];

      if (this.maintenanceFee != 0 && this.maintenList.length == 0) {
        errMsg.push({
          message: "관리비 포함내역을 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      /* 이미지 */
      if (this.G_Img_File.fileList.length < 1) {
        errMsg.push({
          message: " 사진을 등록해주세요.",
          focusId: "ler_step4_GImgUpl",
        });
      }

      if (
        this.G_Img_File.fileList.length > 0 &&
        this.G_Img_File.fileList
          .map((file) => file.size)
          .reduce((acc, curr) => acc + curr) >
          100 * 1000 * 1000
      ) {
        errMsg.push({
          message: " 일반 사진 전체 크키는 100MB를 초과할 수 없습니다.",
          focusId: "ler_step4_GImgUpl",
        });
      }

      /* 건축물대장 */
      if (this.B_Rgt_File.fileList.length < 1) {
        errMsg.push({
          message: " 건축물대장을 등록해주세요.",
          focusId: "ler_detail_BRgtUpl",
        });
      }

      if (
        this.B_Rgt_File.fileList.length > 0 &&
        this.B_Rgt_File.file
          .map((file) => file.size)
          .reduce((acc, curr) => acc + curr) >
          100 * 1000 * 1000
      ) {
        errMsg.push({
          message: " 파일 크키는 100MB를 초과할 수 없습니다.",
          focusId: "ler_detail_BRgtUpl",
        });
      }

      if (errMsg[0] != null) {
        this.isEtv = true;
        document.getElementById(errMsg[0].focusId).focus();

        Message({
          message: errMsg[0].message,
          type: "error",
        });
      }

      if (errMsg[1] != null) {
        Message({
          message: errMsg[1].message,
          type: "error",
          offset: 60,
        });
      }

      if (errMsg[2] != null) {
        Message({
          message: errMsg[2].message,
          type: "error",
          offset: 100,
        });
      }

      if (errMsg[3] != null) {
        Message({
          message: errMsg[3].message,
          type: "error",
          offset: 140,
        });
      }
    },

    async showMessage() {
      let errMsg = [];

      let res = await this.$refs["possibleMoveDateVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "입주 가능일을 확인해주세요.",
          focusId: "ler_step4_contrInfo",
        });
      }

      res = await this.$refs["loanYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "전세자금대출 가능여부를 확인해주세요.",
          focusId: "ler_step4_contrInfo",
        });
      }

      res = await this.$refs["TNORoomsVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방 수를 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["TNOBathRoomsVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "욕실 수를 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["eleYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "승강기 유무를 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["heatingTypeVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "난방방식을 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["heatingFuelVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "난방연료를 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["entStructureVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "현관구조를 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["directionStdVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방향 기준을 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["directionVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방향을 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["parkingYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "주차가능대수를 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      if (Number(this.parkingYn) === 1) {
        res = await this.$refs["pknPerFmlyVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "가구 당 주차대수를 입력해주세요.",
            focusId: "ler_step4_detailInfo",
          });
        }
      }

      res = await this.$refs["maintenanceFeeVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "관리비를 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      res = await this.$refs["useFeeYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "사용료를 확인해주세요.",
          focusId: "ler_step4_detailInfo",
        });
      }

      if (Number(this.useFeeYn) === 1) {
        res = await this.$refs["useFeeListSelectVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "사용료 항목을 선택해주세요.",
            focusId: "ler_step4_detailInfo",
          });
        }
      }

      res = await this.$refs["optionYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "옵션을 확인해주세요.",
          focusId: "ler_step4_extrInfo",
        });
      }

      if (Number(this.optionYn) === 1) {
        res = await this.$refs["optionListSelectVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "옵션 항목을 선택해주세요.",
            focusId: "ler_step4_extrInfo",
          });
        }
      }

      res = await this.$refs["securityYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "보안시설을 확인해주세요.",
          focusId: "ler_step4_extrInfo",
        });
      }

      if (Number(this.securityYn) === 1) {
        res = await this.$refs["securityListSelectVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "보안시설 항목을 선택해주세요.",
            focusId: "ler_step4_extrInfo",
          });
        }
      }

      res = await this.$refs["petYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "반려동물 가능여부를 확인해주세요.",
          focusId: "ler_step4_extrInfo",
        });
      }

      res = await this.$refs["possibleVisitDaysVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방문 가능 요일을 확인해주세요.",
          focusId: "ler_step4_extrInfo",
        });
      }

      res = await this.$refs["possibleVisitTimesVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방문 가능 시간을 확인해주세요.",
          focusId: "ler_step4_extrInfo",
        });
      }

      if (errMsg[0] != null) {
        document.getElementById(errMsg[0].focusId).focus();

        Message({
          message: errMsg[0].message,
          type: "error",
        });
      }

      if (errMsg[1] != null) {
        Message({
          message: errMsg[1].message,
          type: "error",
          offset: 60,
        });
      }

      if (errMsg[2] != null) {
        Message({
          message: errMsg[2].message,
          type: "error",
          offset: 100,
        });
      }
    },

    validate() {
      return this.$refs.form.validate().then((res) => {
        if (!res) {
          this.showMessage(this.$refs.form.errors);
          return;
        }
        this.extraValidation();

        if (this.isEtv) {
          return;
        }

        this.saveStep4Info();
        this.$emit("on-validated", res);
        return res;
      });
    },

    //=================================================================

    printData() {
      console.log(this.loanYn);
    },

    //===============================================================================20201106 him
    initMap() {
      console.log("step4 initmap");
      const container = document.getElementById("step4Map");
      const pptLat = this.certification.propertyLat;
      const pptLong = this.certification.propertyLong;

      const options = {
        // required : 위도(latitude), 경도(longitude)
        center: new kakao.maps.LatLng(pptLat, pptLong),
        level: 3,
      };

      this.jipvioMap = new kakao.maps.Map(container, options);
      this.jipvioGeocoder = new kakao.maps.services.Geocoder();

      // 마커를 생성합니다
      var marker = new kakao.maps.Marker({
        position: new kakao.maps.LatLng(pptLat, pptLong), // 마커를 표시할 위치
        title: "카카오", // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
      });
      this.jipvioMarker = marker;

      this.jipvioMarker.setMap(this.jipvioMap);
    },

    //===============================================================================20201106 him
    // changeMap() {
    //   console.log("step4 changeMap");

    //   //마크 지우기
    //   this.jipvioMarker.setMap(null);
    //   this.jipvioMarker = null;

    //   console.log("step4 change map");

    //   this.jipvioGeocoder.addressSearch(
    //     this.locationInfo.roadFullAddr,
    //     function(result, status) {
    //       console.log("지오코더");
    //       console.log(result);
    //       if (status === kakao.maps.services.Status.OK) {
    //         var coords = new kakao.maps.LatLng(result[0].y, result[0].x);

    //         //마커 생성
    //         var marker = new kakao.maps.Marker({
    //           // map: self.jipvioMap,
    //           position: coords
    //         });

    //         this.jipvioMarker = marker;
    //         this.jipvioMarker.setMap(this.jipvioMap);

    //         //센터 이동
    //         this.jipvioMap.setCenter(coords);
    //       }
    //     }
    //   );
    // },

    applyCommonCode() {
      console.log(this.sessionCoCodeMap);
      //BIO========================================================
      this.sessionCoCodeMap.BIO.forEach((ele, dex) => {
        this.selects.BIO.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //PTT========================================================
      this.sessionCoCodeMap.PTT.forEach((ele, dex) => {
        this.selects.PTT.push({
          value: ele.code,
          label: ele.name,
        });
        this.selects.PTTMap[ele.name] = ele.code;
      });

      //ETT========================================================
      this.sessionCoCodeMap.ETT.forEach((ele, dex) => {
        this.selects.ETT.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //HTT========================================================
      this.sessionCoCodeMap.HTT.forEach((ele, dex) => {
        this.selects.HTT.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //HFT========================================================
      this.sessionCoCodeMap.HFT.forEach((ele, dex) => {
        this.selects.HFT.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //MPM========================================================
      this.sessionCoCodeMap.MPM.forEach((ele, dex) => {
        this.selects.MPM.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //USR========================================================
      this.sessionCoCodeMap.USR.forEach((ele, dex) => {
        this.selects.USR.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //VPD========================================================
      this.sessionCoCodeMap.VPD.forEach((ele, dex) => {
        this.selects.VPD.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //VPT========================================================
      this.sessionCoCodeMap.VPT.forEach((ele, dex) => {
        this.selects.VPT.push({
          value: ele.code,
          label: ele.name,
        });
      });
      //MTN========================================================
      this.sessionCoCodeMap.MTN.forEach((ele, dex) => {
        this.selects.MTN.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //SCF========================================================
      this.sessionCoCodeMap.SCF.forEach((ele, dex) => {
        this.selects.SCF.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //DRT========================================================
      this.sessionCoCodeMap.DRT.forEach((ele, dex) => {
        this.selects.DRT.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //UUF========================================================
      this.sessionCoCodeMap.UUF.forEach((ele, dex) => {
        this.selects.UUF.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //DST========================================================
      this.sessionCoCodeMap.DST.forEach((ele, dex) => {
        this.selects.DST.push({
          value: ele.code,
          label: ele.name,
        });
      });

      console.log("----------");
      console.log(this.selects);
    },

    TNORoomsDirectWrite() {
      if (this.TNORooms == "null") {
        this.TNORooms = null;
        this.TNORoomsDirect = true;
      } else {
        this.TNORoomsDirect = false;
      }
    },

    TNOBathRoomsDirectWrite() {
      if (this.TNOBathRooms == "null") {
        this.TNOBathRooms = null;
        this.TNOBathRoomsDirect = true;
      } else {
        this.TNOBathRoomsDirect = false;
      }
      console.log(this.TNOBathRoomsDirect);
    },

    delPMD() {
      if (this.imdMove == true) {
        this.possibleMoveDate = "0000-00-00";
      } else {
        this.possibleMoveDate = null;
      }
      console.log(this.possibleMoveDate);
    },

    // 건축물대장 파일첨부시(업로드x) 이벤트
    BRgt_UploadChange: function (file, fileList) {
      console.log("fileList: ", fileList);
      this.B_Rgt_File.fileList = fileList;
      this.B_Rgt_File.fileList.forEach((file) => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.B_Rgt_File.fileList.splice(
            this.B_Rgt_File.fileList.indexOf(file),
            1
          );
          return;
        }
      });
    },
    // 건축물대장 선택한 파일 삭제
    BRgt_RemoveFile: function (file, fileList) {
      this.B_Rgt_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.B_Rgt_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },
    // 건축물대장 지정한 파일갯수를 초과해서 첨부했을 때
    BRgt_ExceedFileLimit: function () {
      Message.warning("파일첨부는 1개까지만 가능합니다.");
    },

    // 일반이미지 파일첨부시(업로드x) 이벤트
    G_UploadChange: function (file, fileList) {
      console.log("fileList: ", fileList);
      this.G_Img_File.fileList = fileList;
      this.G_Img_File.fileList.forEach((file) => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.G_Img_File.fileList.splice(
            this.G_Img_File.fileList.indexOf(file),
            1
          );
          return;
        }
      });
    },
    // 일반이미지 선택한 파일 삭제
    G_RemoveFile: function (file, fileList) {
      this.G_Img_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.G_Img_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },
    // 일반이미지 지정한 파일갯수를 초과해서 첨부했을 때
    G_ExceedFileLimit: function () {
      Message.warning("파일첨부는 3개까지만 가능합니다.");
    },

    // 열화상이미지 파일첨부시(업로드x) 이벤트
    TH_UploadChange: function (file, fileList) {
      console.log("fileList: ", fileList);
      this.TH_Img_File.fileList = fileList;
      this.TH_Img_File.fileList.forEach((file) => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.TH_Img_File.fileList.splice(
            this.TH_Img_File.fileList.indexOf(file),
            1
          );
          return;
        }
      });
    },
    // 열화상이미지 선택한 파일 삭제
    TH_RemoveFile: function (file, fileList) {
      this.TH_Img_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.TH_Img_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },
    // 열화상이미지 지정한 파일갯수를 초과해서 첨부했을 때
    TH_ExceedFileLimit: function () {
      Message.warning("파일첨부는 3개까지만 가능합니다.");
    },

    // VR이미지 파일첨부시(업로드x) 이벤트
    VR_UploadChange: function (file, fileList) {
      console.log("fileList: ", fileList);
      this.VR_Img_File.fileList = fileList;
      this.VR_Img_File.fileList.forEach((file) => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.VR_Img_File.fileList.splice(
            this.VR_Img_File.fileList.indexOf(file),
            1
          );
          return;
        }
      });
    },
    // 열화상이미지 선택한 파일 삭제
    VR_RemoveFile: function (file, fileList) {
      this.VR_Img_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.VR_Img_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },
    // 열화상이미지 지정한 파일갯수를 초과해서 첨부했을 때
    VR_ExceedFileLimit: function () {
      Message.warning("파일첨부는 3개까지만 가능합니다.");
    },
  },
};
</script>
<style>
.Progress ul li .P-arrow {
  font-size: 33px;
  position: absolute;
  top: 50%;
  right: 15%;
  transform: translate(-15%, -50%);
}

.uploadFile .el-upload-list {
  position: absolute;
  top: -1px;
  right: 0;
  width: 75%;
}
</style>
